// @ts-nocheck
import dom from "../../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;
import IconButton from "./IconButton.jsx";

/**
 * @param {Object}   props
 * @param {string}   [props.label='Copy']
 * @param {function} props.onClick
 * @param {boolean}  props.showToolTip
 * @return {HTMLElement}
 */
const CopyButton = props => {
	return <IconButton
		className="aa-btn-general aa-btn-ext-icon btn-actions js-aa-tt-btns"
		icon="aa-icon-copy-square aa-icon-mask"
		onClick={props.onClick}
		showToolTip={props.showToolTip}
		tippyOptions={{placement: "bottom"}}
		tooltipText={props.label || "Copy"}
	/>;
};

export const copiedConfirmationMsg = "Copied to clipboard.";

export default CopyButton;
